<template>
    <div class="order">
        <div>
            <div class="status" v-if="status==1">
                <div><img src="../../assets/order/status1.png" >恭喜双方意愿达成</div>
                <div>请在{{orderDetails.contractDate|orderTime}}前完成线下合同签约</div>
            </div>

            <div class="status" v-if="status==3">
                 <div><img src="../../assets/order/status3.png" >交易成功，订单已完成</div>
                <div>感谢您的参与</div>
            </div>

            <div class="status" v-if="status==4">
                 <div><img src="../../assets/order/status4.png" >交易失败</div>
                <div>请下次再来</div>
            </div>

            <div class="order_table">
                <div class="title">鄂尔多斯西北能源化工</div>
                <div class="table">
                    <div>
                        <div>产品</div>
                        <div>数量</div>
                        <div>竞拍价</div>
                        <div>订单总价</div>
                    </div>
                    <div>
                        <div>
                            <span v-if="orderDetails.msg == ' '||!orderDetails.msg">{{orderDetails.title}}</span>
                            <span v-else>{{orderDetails.title}}·{{orderDetails.msg}}</span>
                        </div>
                        <div>{{orderDetails.bidAmount}}{{orderDetails.numUnit}}</div>
                        <div>¥{{orderDetails.bidPrice}}/{{orderDetails.unitedTitle==null?'吨':orderDetails.unitedTitle}}
                        </div>
                        <div class="red">¥{{orderDetails.countPrice}}</div>
                    </div>
                </div>
            </div>
            <div class="order_table">
                <div class="table">
                    <div>
                        <div>订单编号</div>
                        <div>创建日期</div>
                        <div>取货截止日期</div>
                        <div>取货地点</div>
                        <div>完成时间</div>
                    </div>
                    <div>
                        <div>{{orderDetails.orderNumber}}</div>
                        <div>{{orderDetails.createTime|orderTime}}</div>
                        <div>{{orderDetails.pickUpEndTime|orderTime}}</div>
                        <div>{{orderDetails.pickUpAddress}}</div>
                        <div v-if="!orderDetails.compeleteTime">
                            未完成
                        </div>
                        <div v-else>
                            {{orderDetails.compeleteTime|orderTime}}
                        </div>
                    </div>
                </div>
                <div class="btn" v-if="orderDetails.userId==$store.state.userId&&status=='1'">
                    <div class="btn_1" @click="confirmOrder">确定订单</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Order",
        data() {
            return {
                orderId: '', //订单Id
                dealType: 'B', //订单Id
                orderDetails: '', //订单详情
                offerAPrice: 0, //出价
                quantity: 0, //数量
                aggregate: 0, //总价
                anonymous: false, //是否匿名
                status: null
            }
        },
        created() {
            this.orderId = this.$route.query.orderId;
            this.getOrder();
        },
        methods: {
            //确定订单
            confirmOrder: function() {
                var that = this;
                that.$confirm('确定订单 ：已经签署线下合同，确认订单', '确认提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        biddingOrdersId: that.orderId,
                        bidDealId: that.orderDetails.productId
                    }
                    that.request({
                        method: 'post',
                        url: this.$store.state.httpUrl + "mobileInterf/confirmOrder",
                        params
                    }).then(res => {
                        if (res.status == 200) {
                            this.getOrder();
                        }
                    });
                })
            },
            getOrder() {
                if (this.$route.query.anonymous) {
                    this.anonymous = true;
                }
                this.request.get(this.$store.state.httpUrl + "mobileInterf/queryMyOrderDetail", {
                    params: {
                        orderId: this.$route.query.orderId,
                        dealType: 'B',
                        userId: this.$route.query.userId
                    }
                }).then(res => {
                    if (res.status == 200) {
                        this.orderDetails = res.data;
                        this.status = res.data.status;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .order {
        background: #FFFFFF;
        padding-bottom: 50px;
    }

    .order>div {
        width: 1200px;
        margin: 0 auto;
    }

    .status {
        display: flex;
        justify-content: space-between;
        width: 1200px;
        height: 80px;
        background: #E9F4FF;
        border-radius: 10px;
        box-sizing: border-box;
        line-height: 80px;
        padding: 0 24px;
    }

    .status>div:nth-child(1) {
        font-size: 24px;
        font-weight: bold;
        color: #5F93FF;
    }

    .status>div:nth-child(1)>img {
        height: 40px;
        width: auto;
        vertical-align: middle;
        margin-right: 30px;
    }

    .status>div:nth-child(2) {
        font-size: 18px;
        color: #666666;
    }

    .order_table {
        border: 1px solid #CCCCCC;
        border-radius: 10px;
        padding: 24px;
        box-sizing: border-box;
        margin-top: 24px;
    }

    .order_table>.title {
        font-size: 14px;
        color: #666666;
        padding-bottom: 18px;
    }

    .order_table>.table>div {
        display: flex;
        justify-content: space-between;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        color: #333333;
    }

    .order_table>.table>div>div {
        flex: 1;
        text-align: center;
        border-bottom: 1px solid #CCCCCC;
    }

    .order_table>.table>div:nth-child(1) {
        background: #F5F5F6;
    }


    .btn {
        display: flex;
        justify-content: space-around;
    }

    .btn>div {
        width: 222px;
        height: 46px;
        border-radius: 8px;
        text-align: center;
        line-height: 46px;
        font-size: 16px;
        margin: 0 auto;
        margin-top: 24px;
        cursor: pointer;
    }

    .btn_1 {
        background: #5F93FF;
        color: #FFFFFF;
    }

    .btn_2 {
        background: #FFD9D9;
        color: #F54646;
    }

    .btn_3 {
        background: #CFDEFF;
        color: #5F93FF;
    }
</style>



// WEBPACK FOOTER //
// src/view/shop/orderJp.vue